import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import { apiClient } from "app/configs/apiClient";
import { navbarClose } from "app/store/fuse/navbarSlice";
import { selectUser } from "app/store/userSlice";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const Instagram = () => {
    const navigate = useNavigate();
    const path = useLocation();
    const dispatch = useDispatch();

    const [metaPages, setMetaPages] = useState([]);
    const [selectedPage, setSelectedPage] = useState();
    const [setsuccessMessage, setSetsuccessMessage] = useState("");

    const { institutionGatewayDetailId } = useSelector(
        (state) => state.fuse.selectLocation
    );

    const user = useSelector(selectUser);

    const params = new URLSearchParams(window.location.search);
    const instagramCode = params.get("code");

    const institutonMasterId = user?.data?.institutionMasterId;
    const platformId = 4;

    useEffect(() => {
        const fetchInstagramAccess = async () => {
            if (
                !institutionGatewayDetailId ||
                !instagramCode ||
                !institutonMasterId
            ) {
                console.warn("Missing required parameters for Instagram access.");
                return;
            }

            const url = `/instagram/callback?code=${instagramCode}&gateway_details_id=${institutionGatewayDetailId}&platform_id=${platformId}&institution_master_id=${institutonMasterId}`;

            try {
                const response = await apiClient().get(url);
                const accessCode = response?.data?.code;

                if (accessCode) {
                    await getAccessToken(accessCode);
                } else {
                    console.warn("No accessCode returned from Instagram callback.");
                }
            } catch (error) {
                console.error("Error fetching Instagram data:", error);
            }
        };

        fetchInstagramAccess();
    }, [institutionGatewayDetailId, instagramCode, institutonMasterId]);

    // Function to get the access token using the access code
    const getAccessToken = async (accessCode) => {
        try {
            const response = await apiClient().post(
                `/instagram/access_token?code=${accessCode}&gateway_details_id=${institutionGatewayDetailId}&platform_id=${platformId}&institution_master_id=${institutonMasterId}`
            );
            setMetaPages(response?.data?.data?.data);
        } catch (error) {
            console.error("Error getting Instagram access token:", error);
        }
    };

    const handlePageSelect = async (event) => {
        const selected = event.target.value;
        setSelectedPage(selected);

        if (selected) {
            await getInstagramBusinessAccount(selected);
        }
    };

    const getInstagramBusinessAccount = async (selectedPage) => {
        try {
            const token = localStorage.getItem("jwt_access_token");
            const response = await apiClient().post(
                `/instagram/business/accounts?platform_id=${platformId}&gateway_details_id=${institutionGatewayDetailId}`,
                selectedPage,
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );
            toast.success(response?.data?.message);
            setSetsuccessMessage(response?.data?.message);
            if (response?.data?.sucess === true) {
                navigate("/integration");
            }
        } catch (error) {
            console.error("Error fetching Instagram business account:", error);
        }
    };

    return (
        <>
            <h3>Instagram Integration</h3>
            <Grid
                container
                sx={{
                    bgcolor: "",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        width: 500,
                        bgcolor: "",
                        borderRadius: 5,
                        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        mb: 5,
                        pb: 5,
                    }}
                >
                    <Grid container sx={{ justifyContent: "center" }}>
                        <Box
                            component="img"
                            src="/assets/images/logo/logo-image.png"
                            sx={{ width: "45%" }}
                        />
                    </Grid>
                    {metaPages.length > 0 && (
                        <Grid container sx={{ justifyContent: "center", mb: 5 }}>
                            <FormControl
                                sx={{
                                    minWidth: 300,
                                }}
                            >
                                <InputLabel id="demo-simple-select-label">
                                    Choose Pages
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    // value={"12"}
                                    label="Choose Pages"
                                    value={selectedPage || ""}
                                    onChange={handlePageSelect}
                                // onChange={(e) => setSelectedPage(e.target.value)}
                                >
                                    {metaPages?.map((data, index) => (
                                        <MenuItem value={data}>{data?.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                </Box>
            </Grid>
        </>
    );
};

export default Instagram;
